import React from 'react';
import { Check } from 'lucide-react';
import Card, { CardHeader, CardTitle, CardContent } from './ui/Card';

const BulletPoint = ({ text }) => (
  <li className="flex items-center">
    <Check className="h-5 w-5 text-secondary mr-2" />
    <span className="text-gray-700">{text}</span>
  </li>
);

const ApplicationCard = ({ 
  title, 
  description, 
  bulletPoints = [], 
  accentColor = "secondary",
  variant = "standard" // "standard" or "simple"
}) => {
  if (variant === "simple") {
    // Map color names to tailwind classes to avoid string interpolation which doesn't work with Tailwind
    const colorClasses = {
      primary: "bg-primary",
      secondary: "bg-secondary",
      accent: "bg-accent"
    };
    
    const textColorClasses = {
      primary: "text-primary",
      secondary: "text-secondary",
      accent: "text-gray-800"
    };
    
    return (
      <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 flex flex-col">
        <div className={`${colorClasses[accentColor]} h-3`}></div>
        <div className="p-6 flex flex-col h-full">
          <div>
            <h3 className={`text-2xl font-bold ${textColorClasses[accentColor]} h-16 mb-4`}>{title}</h3>
            <p className="text-gray-700 min-h-[80px]">{description}</p>
          </div>
          {bulletPoints.length > 0 && (
            <div className="border-t border-gray-200 pt-4 mt-4 w-full">
              <p className={`${textColorClasses[accentColor]} font-semibold`}>Impact:</p>
              <p className="text-gray-700">{bulletPoints[0]}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
  
  return (
    <Card accent accentColor={accentColor}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <p className="text-gray-600 mb-4">{description}</p>
      </CardHeader>
      {bulletPoints.length > 0 && (
        <CardContent>
          <ul className="space-y-2">
            {bulletPoints.map((point, index) => (
              <BulletPoint key={index} text={point} />
            ))}
          </ul>
        </CardContent>
      )}
    </Card>
  );
};

export default ApplicationCard;
export { BulletPoint };